import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import ItemModify from '../Form/ItemModify';

@inject('unitStore')
@observer
class UnitModify extends Component {
  render() {
    const { unitStore, params } = this.props;
    return (
      <ItemModify
      title='Unit'
      slug = '/unit'
      store = {unitStore}
      itemFields = {[
        { label: 'Id', key: 'id', type: 'text', readOnly : true, editOnly : true},
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Symbol', key: 'symbol', type: 'text' },
      ]}
      params={params}
      />
    );
  }
}

export default UnitModify;



// WEBPACK FOOTER //
// ./src/components/Unit/UnitModify.js